import { ITimeout } from '@src/constants';

export const timeout = (ms: ITimeout | number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
